import React from 'react'
import {useState, useRef, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { hideWindow, closeWindow, focusWindow } from '../slices/mwSelectSlice';
import Draggable from "react-draggable";
import { InView } from 'react-intersection-observer';

const Window = ({mwType, content, allowResize, allowFS, baseWidth, baseHeight}) => {
    const contentRef = useRef()
    const bodyRef = useRef()
    const handleRef = useRef()
    const windowRef = useRef()
    //const adjBaseWidth = baseWidth - 35
    const asjBaseHeight = baseHeight
    const baseLeft = 25
    const baseTop = 10
    const windowCheck = useSelector((state) => state.shower.window);
    const dispatch = useDispatch()
    const [bodyWidth, setBodyWidth] = useState(baseWidth) 
    const [bodyHeight, setBodyHeight] = useState(baseHeight)
    const [lastBodyWidth, setLastBodyWidth] = useState(baseWidth) 
    const [lastBodyHeight, setLastBodyHeight] = useState(baseHeight)
    const [resize, setResize] = useState('both')
    const [leftPos, setLeftPos] = useState(baseLeft)
    const [topPos, setTopPos] = useState(baseTop)
    const [lastLeftPos, setLastLeftPos] = useState(baseLeft)
    const [lastTopPos, setLastTopPos] = useState(baseTop)
    const [fsPressed, setFsPressed] = useState(0)
    const [allowDrag, setAllowDrag] = useState(true)
    const [resetPos, setResetPos] = useState(false)

    let doZeroTrans = 1;
    const mainWindowDivID = mwType + '-main-div'
    //const leftPos = Math.floor(Math.random() * (60 - 40 + 1) ) + 25
    //const topPos = Math.floor(Math.random() * (50 - 25 + 1) ) + 25

    const [inView, setInView] = useState(false);
    useEffect(() => {
      window.addEventListener("mousedown", windowBoundaryHandler);
      //window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener("mousedown", windowBoundaryHandler);
        //window.removeEventListener('resize', handleResize);
      };
    }, []);

    useEffect(() => {
      if(!windowCheck.find((w) => w.windowID === mwType).reset){
        setResetPos(false)
      }
    }, [windowCheck.find((w) => w.windowID === mwType).reset]);

    const handleResize = () => {
      resizeBar()
    }

    const windowBoundaryHandler = () => {
      console.log(windowRef.current.getBoundingClientRect().top)
      if(windowRef.current.getBoundingClientRect().top >= 0){
        console.log('past top')
      }
    }

    const closeW = () =>{
      
      //windowRef.current.style.transform = ""
      setBodyWidth(baseWidth)
      setBodyHeight(baseHeight)
      setLeftPos(baseLeft)
      setTopPos(baseTop)
      setLastLeftPos(baseLeft)
      setLastTopPos(baseTop)
      setLastBodyWidth(bodyWidth)
      setLastBodyHeight(bodyHeight)
      setFsPressed(0)
      setResize('both')
      setResetPos(true)
      dispatch(closeWindow(mwType))
      bodyRef.current.style.transform = "translate(0px, 0px)"
    }

    const fullW = () =>{
      // console.log(window.innerHeight*.95 + ' 95% Ih')
      // console.log(bodyWidth + ' wb B')
      // console.log(bodyHeight + ' b B')
      // console.log(lastBodyHeight + ' lb B')
      bodyRef.current.style.transform = ""
      if(!fsPressed){
        bodyRef.current.style.transform = ""
        setResize('none')
        setLastLeftPos(leftPos)
        setLastTopPos(topPos)
        setLeftPos(0)
        setTopPos(0)
        setFsPressed(1)
        setLastBodyWidth(bodyWidth)
        setLastBodyHeight(contentRef.current.clientHeight)
        setBodyWidth(window.innerWidth)
        setBodyHeight(window.innerHeight*.95 - 35)
        setAllowDrag(false)
        
        
        
      }else{
        setResize('both')
        setFsPressed(0)
        bodyRef.current.style.transform = ""
        setBodyWidth(lastBodyWidth)
        setBodyHeight(lastBodyHeight)
        setLastBodyWidth(bodyWidth)
        setLastBodyHeight(bodyHeight)
        setLeftPos(lastLeftPos)
        setTopPos(lastTopPos)
        setLastLeftPos(leftPos)
        setLastTopPos(topPos)
        setAllowDrag(true)
        //bodyRef.current.click()
      }
      
      //resizeBar()
    }

    const hideW = () =>{
      dispatch(hideWindow(mwType))
      resizeBar()
    }

    const resizeBar = () => {
      setBodyWidth(bodyWidth => contentRef.current.offsetWidth)
      setBodyHeight(bodyHeight => contentRef.current.clientHeight)
      

    }

    const updatePos = () => {
      if(fsPressed && doZeroTrans){
        windowRef.current.style.transform = ""
        doZeroTrans = 0
      }

      //setLeftPos(Math.round(bodyRef.current.offsetLeft/window.innerWidth * 100) )
      //setTopPos(Math.round(bodyRef.current.offsetTop/window.innerHeight * 100) )
    }
    //

    const updatePosition = () => {
      setLeftPos(windowRef.current.offsetLeft)
      setTopPos(windowRef.current.offsetTop)
      windowRef.current.style.transform = ""
    }
    const zIndexUpdate = () =>{
      dispatch(focusWindow(mwType))
    }
    return (
    <Draggable ref={windowRef} handle='.handle' axis={'both'} 
    allowDrag={allowDrag} onStart={updatePos}  onStop={updatePos}
    onDrag={()=>updatePosition}
    onMouseDown={zIndexUpdate} 
    bounds={{left: -.25*window.innerWidth, top: -.10*window.innerHeight, right: window.innerWidth - (.25*window.innerWidth+bodyWidth), bottom: window.innerHeight - (.15*window.innerHeight + bodyHeight+35)}}
    
    >
    
      <div className={'meow-'+mwType}  ref={bodyRef} style={{
        zIndex: windowCheck.find((w) => w.windowID === mwType).zIndex,
         display: windowCheck.find((w) => w.windowID === mwType).display,
          width: bodyWidth, height: bodyHeight,
          background: 'transparent',
          position: 'absolute',
          left: `${leftPos}%`,
           top: `${topPos}%`}}>
          <div className='handle'  
          ref={handleRef}
          style={{ backgroundColor:'rgb(76, 201, 240)',
          width: bodyWidth, 
          height: '25px', 
          borderRadius: '5px', 
          position: 'relative',
          boxSizing: 'border-box', 
          border: '2px outset rgb(76, 201, 240)',
          display: 'inline-block'
          //outlineOffset: '-2px',
          }}>
            <p style={{
              display: 'inline-block', 
              paddingLeft:'1%', 
              paddingTop:'3px', 
              margin: '0px',
              //paddingTop: '0.5%',
              //color: 'white',
              fontFamily: '"Terminal", monospace',
              fontSmooth: 'never',  
              //textShadow: '1px 2px black', 
              position: 'absolute',
              textOverflow: 'ellipsis',}}>
                {windowCheck.find((w) => w.windowID === mwType).title}
            </p>

            <button onClick={() => fullW()}
              style={{ 
                marginLeft: bodyWidth-70 + 'px', 
                marginTop: '3px', 
                display: allowFS ? 'inline-block' : 'none', 
                position: 'absolute', 
                borderRadius:'50%', 
                width: '16px', 
                height: '16px', 
                border: '1px solid black', 
                backgroundColor: fsPressed ? 'rgb(245, 101, 34)' : 'rgb(102, 255, 102)',
                cursor: 'pointer',
                }}>
              
            </button>

            <button onClick={() => hideW()}
              style={{ 
                marginLeft: bodyWidth-50 + 'px', 
                marginTop: '3px', 
                display: 'inline-block', 
                position: 'absolute', 
                borderRadius:'50%', 
                width: '16px', 
                height: '16px', 
                border: '1px solid black', 
                backgroundColor: 'rgb(255, 255, 77)',
                cursor: 'pointer',
                }}>
              
            </button>
            <button onClick={() => closeW()} 
              style={{ 
                marginLeft: bodyWidth-30 + 'px', 
                marginTop: '3px', 
                display: 'inline-block', 
                position: 'absolute', 
                borderRadius:'50%', 
                width: '16px', 
                height: '16px', 
                border: '1px solid black', 
                backgroundColor: 'rgb(255, 128, 128)',
                cursor: 'pointer',
                }}>
              
            </button>

            
          </div>
          <div ref={contentRef}s onMouseDown={() => resizeBar()} onClick={() => resizeBar()} className='body' 
          style={{ backgroundColor:'rgb(235, 186, 164)', 
          //margin: 'auto',
          width: bodyWidth, 
          height: (bodyHeight),
          boxSizing: 'border-box', 
          outline: '5px ridge rgb(235, 186, 178)',
          outlineOffset: '-5px',
          padding: '5px',
          marginTop: '5px' , 
          resize: allowResize ? `${resize}`: 'none', 
          overflow: 'auto', 
          position: 'absolute'}}>
            {content}
          </div>
      </div>     
    </Draggable>
  )
}



export default Window